import ht from "../images/ht.svg";
import css from "../images/css.svg";
import sass from "../images/sass.svg";
import responsive from "../images/responsive1.svg";
import js from "../images/js.svg";
import react from "../images/react.svg";
import gulp from "../images/gulp.svg";
import git from "../images/git.svg";
import github from "../images/github.svg";
import vscode from "../images/vscode.svg";
import node from "../images/node.svg";

const hardSkills = [
  {
    id: 1,
    name: "HTML5",
    img: ht,
  },
  {
    id: 2,
    name: "CSS3",
    img: css,
  },
  {
    id: 3,
    name: "SASS",
    img: sass,
  },

  {
    id: 4,
    name: "Responsive",
    img: responsive,
  },
  {
    id: 5,
    name: "JavaScript",
    img: js,
  },

  ,
  {
    id: 6,
    name: "React",
    img: react,
  },

  {
    id: 7,
    name: "Gulp",
    img: gulp,
  },
  {
    id: 8,
    name: "Git",
    img: git,
  },
  {
    id: 9,
    name: "GitHub",
    img: github,
  },

  {
    id: 10,
    name: "VSCode",
    img: vscode,
  },
  {
    id: 11,
    name: "Node Js",
    img: node,
  },
];

export default hardSkills;
